import _styled, { default as _styled2 } from "styled-components";
import { observer } from "mobx-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Section = styled(Box).attrs({
  paddedHorizontally: true
}).withConfig({
  displayName: "LocationBar__Section",
  componentId: "sc-gj31bn-0"
})([""]);
const StyledText = styled.span.withConfig({
  displayName: "LocationBar__StyledText",
  componentId: "sc-gj31bn-1"
})(["font-family:", ";color:", ";white-space:nowrap;font-size:0.7rem;padding:0 5px 0 5px;"], props => props.theme.fontMono, props => props.theme.textLight);
const setInnerText = (ref, value) => {
  if (ref.current) ref.current.innerText = value;
};
export const LocationBar = observer(_ref => {
  let {
    mouseCoords
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const elevationRef = useRef(null);
  const longitudeRef = useRef(null);
  const latitudeRef = useRef(null);
  const utmZoneRef = useRef(null);
  const eastRef = useRef(null);
  const northRef = useRef(null);
  useEffect(() => {
    const disposer = mouseCoords.updateEvent.addEventListener(() => {
      var _mouseCoords$elevatio, _mouseCoords$longitud, _mouseCoords$latitude, _mouseCoords$utmZone, _mouseCoords$east, _mouseCoords$north;
      setInnerText(elevationRef, (_mouseCoords$elevatio = mouseCoords.elevation) !== null && _mouseCoords$elevatio !== void 0 ? _mouseCoords$elevatio : "");
      setInnerText(longitudeRef, (_mouseCoords$longitud = mouseCoords.longitude) !== null && _mouseCoords$longitud !== void 0 ? _mouseCoords$longitud : "");
      setInnerText(latitudeRef, (_mouseCoords$latitude = mouseCoords.latitude) !== null && _mouseCoords$latitude !== void 0 ? _mouseCoords$latitude : "");
      setInnerText(utmZoneRef, (_mouseCoords$utmZone = mouseCoords.utmZone) !== null && _mouseCoords$utmZone !== void 0 ? _mouseCoords$utmZone : "");
      setInnerText(eastRef, (_mouseCoords$east = mouseCoords.east) !== null && _mouseCoords$east !== void 0 ? _mouseCoords$east : "");
      setInnerText(northRef, (_mouseCoords$north = mouseCoords.north) !== null && _mouseCoords$north !== void 0 ? _mouseCoords$north : "");
    });
    return disposer;
  });
  return /*#__PURE__*/_jsx(_StyledBox, {
    styledHeight: "30px",
    col: true,
    verticalCenter: true,
    children: /*#__PURE__*/_jsxs(_StyledRawButton, {
      onClick: mouseCoords.toggleUseProjection,
      $_css: theme.colorPrimary,
      children: [!mouseCoords.useProjection ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Section, {
          centered: true,
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: t("legend.lat")
          }), /*#__PURE__*/_jsx(StyledText, {
            ref: latitudeRef,
            children: mouseCoords.latitude
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          centered: true,
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: t("legend.lon")
          }), /*#__PURE__*/_jsx(StyledText, {
            ref: longitudeRef,
            children: mouseCoords.longitude
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: t("legend.zone")
          }), /*#__PURE__*/_jsx(StyledText, {
            ref: utmZoneRef,
            children: mouseCoords.utmZone
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: t("legend.e")
          }), /*#__PURE__*/_jsx(StyledText, {
            ref: eastRef,
            children: mouseCoords.east
          })]
        }), /*#__PURE__*/_jsxs(Section, {
          children: [/*#__PURE__*/_jsx(StyledText, {
            children: t("legend.n")
          }), /*#__PURE__*/_jsx(StyledText, {
            ref: northRef,
            children: mouseCoords.north
          })]
        })]
      }), /*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(StyledText, {
          children: t("legend.elev")
        }), /*#__PURE__*/_jsx(StyledText, {
          ref: elevationRef,
          children: mouseCoords.elevation
        })]
      })]
    })
  });
});
var _StyledBox = styled(Box).withConfig({
  displayName: "LocationBar___StyledBox",
  componentId: "sc-gj31bn-2"
})(["padding-top:3px;padding-bottom:3px;"]);
var _StyledRawButton = styled(RawButton).withConfig({
  displayName: "LocationBar___StyledRawButton",
  componentId: "sc-gj31bn-3"
})(["display:flex;align-items:center;height:100%;&:hover{background:", ";}"], p => p.$_css);